import { useSelector, shallowEqual } from 'react-redux';

import { selectSlice as selectConsumption } from 'state/consumption/consumption-slice';
import { selectIsDirectConsumption } from 'state/consumption-entry/consumption-entry-slice';
import type { FUEL_TYPES } from 'config/app-config';

type consumptionReturnType = {
  consumption: {
    [FUEL_TYPES.GAS]?: number;
    [FUEL_TYPES.ELECTRIC]?: number;
  };
  isDirectConsumptionInput: boolean;
};

export const useConsumption = (): consumptionReturnType => {
  const consumption = useSelector(selectConsumption, shallowEqual);
  const isDirectConsumptionInput = useSelector(
    selectIsDirectConsumption,
    shallowEqual
  );
  return { consumption, isDirectConsumptionInput };
};
